import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import { Modal, Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Swal from "sweetalert2";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";


function EditHospitals() {
    const [HospName, setHospName] = useState("");
    const [HospCode, setHospCode] = useState("");
    const [HospContact, setHospContact] = useState("");
    const [HospCountry, setHospCountry] = useState("");
    const [HospState, setHospState] = useState("");
    const [HospDistrict, setHospDistrict] = useState("");
    const [HospAddress, setHospAddress] = useState("");
    const [HospPin, setHospPin] = useState("");
    const [HospEmail, setHospEmail] = useState("");
    const [HospWebsite, setHospWebsite] = useState("");
    const [HospCoord, setHospCoord] = useState("");
    const [HospServedBy, setHospServedBy] = useState(""); // Added for staff assignment
    const accessuserid = localStorage.getItem("id");

    const [cntry_name, setcntry_name] = useState([]);
    const [state_name, setstate_name] = useState([]);
    const [district_name, setdistrict_name] = useState([]);
    const [staffList, setStaffList] = useState([]); // Added for staff list

    const { hosp_id } = useParams();
    const accesstoken = localStorage.getItem("token");
    const navigate = useNavigate();
    
    useEffect(() => {
        const getCountry = async () => {
            try {
                const res = await axios.get(
                    baseurladdress + "staff/getallcountry",
                    { headers: { Authorization: `Bearer ${accesstoken}` } }
                );
                if (res.data.status === "Success") {
                    setcntry_name(res.data.countries || []);
                }
            } catch (err) {
                console.error(err);
            }
        };
        getCountry();
    }, [accesstoken]);

    // Added: Fetch staff list
    useEffect(() => {
        const getAllStaff = async () => {
            try {
                const res = await axios.get(baseurladdress + "staff/findallstaff", {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                });
                if (res.data.status === "Success") {
                    setStaffList(res.data.staff || []);
                } else {
                    setStaffList([]);
                }
            } catch (err) {
                console.error(err);
                setStaffList([]);
            }
        };
        getAllStaff();
    }, [accesstoken]);

    // load states if country is already selected
    useEffect(() => {
        if (!HospCountry) return;

        const loadStates = async () => {
            try {
                const res = await axios.get(
                    baseurladdress + `staff/getstates/${HospCountry}`,
                    { headers: { Authorization: `Bearer ${accesstoken}` } }
                );
                setstate_name(res.data.states || []);
            } catch (err) {
                console.error(err);
            }
        };
        loadStates();
    }, [HospCountry, accesstoken]);

    // load districts if state is already selected
    useEffect(() => {
        if (!HospState) return;

        const loadDistricts = async () => {
            try {
                const res = await axios.get(
                    baseurladdress + `staff/getdistricts/${HospState}`,
                    { headers: { Authorization: `Bearer ${accesstoken}` } }
                );
                setdistrict_name(res.data.districts || []);
            } catch (err) {
                console.error(err);
            }
        };
        loadDistricts();
    }, [HospState, accesstoken]);

    // handlers
    const onCountryChange = (countryId) => {
        setHospCountry(countryId);
        setHospState("");
        setHospDistrict("");
        setstate_name([]);
        setdistrict_name([]);
    };

    const onStateChange = (stateId) => {
        setHospState(stateId);
        setHospDistrict("");
        setdistrict_name([]);
    };

    useEffect(() => {
        axios
            .get(baseurladdress + `hospital/edithospital/${hosp_id}`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const data = res.data.hospital;

                    setHospName(data.hosp_name);
                    setHospCode(data.hosp_code);
                    setHospContact(data.hosp_contact);
                    setHospCountry(data.hosp_country);
                    setHospState(data.hosp_state);
                    setHospDistrict(data.hosp_district);
                    setHospAddress(data.hosp_address);
                    setHospPin(data.hosp_pin);
                    setHospEmail(data.hosp_email);
                    setHospWebsite(data.hosp_website);
                    setHospCoord(data.hosp_coord);
                    setHospServedBy(data.hosp_servedby || ""); // Added staff assignment


                } else {
                    console.warn("Hospital not found");
                }
            })
            .catch((error) => {
                console.error("Edit hospital fetch error:", error);
            });
    }, [hosp_id]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const data = {
            hosp_id: hosp_id,
            hosp_name: HospName,
            hosp_code: HospCode,
            hosp_contact: HospContact,
            hosp_country: HospCountry,
            hosp_state: HospState,
            hosp_district: HospDistrict,
            hosp_address: HospAddress,
            hosp_pin: HospPin,
            hosp_email: HospEmail,
            hosp_website: HospWebsite,
            hosp_coord: HospCoord,
            hosp_servedby: HospServedBy, // Added staff assignment
            hosp_updby: accessuserid,
        };

        fetch(baseurladdress + "hospital/updatehospital", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 800,
                    timerProgressBar: true,
                });

                if (result.status === "updated") {
                    Toast.fire({
                        icon: "success",
                        title: "Hospital Updated Successfully",
                    });
                    navigate("/hospital");
                } else {
                    Toast.fire({
                        icon: "error",
                        title: "Something went wrong",
                    });
                }
            })
            .catch((error) => {
                console.error("Hospital update error:", error);
            });
    };


    return (
        <div className="staff-page">
            <div className="staff-container">
                <div className="staff-header">
                    <NavLink to="/hospital">
                        <div className="float">
                            <i className="fa fa-arrow-left my-float"></i>
                        </div>
                    </NavLink>
                </div>

                <form onSubmit={handleSubmit} className="staff-form">
                    <div className="staff-columns">

                        {/* LEFT COLUMN */}
                        <div className="staff-column">
                            <div className="staff-card">
                                <div className="staff-card-body">

                                    <div className="card-header">
                                        <h4 className="card-title">EDIT HOSPITAL</h4>
                                        <div className="staff-heading-divider"></div>
                                    </div>

                                    <div className="staff-fields">

                                        <div className="staff-group">
                                            <label>Hospital Name <span className="staff-required">*</span></label>
                                            <input
                                                type="text"
                                                value={HospName}
                                                onChange={(e) => setHospName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Hospital Code <span className="staff-required">*</span></label>
                                            <input
                                                type="text"
                                                value={HospCode}
                                                onChange={(e) => setHospCode(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Contact <span className="staff-required">*</span></label>
                                            <input
                                                type="text"
                                                value={HospContact}
                                                onChange={(e) => setHospContact(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <h6><span style={{ color: "red" }}>*</span>Country</h6>
                                            <select
                                                className="form-control select"
                                                value={HospCountry}
                                                onChange={(e) => onCountryChange(e.target.value)}
                                            >
                                                <option value="">Select</option>
                                                {cntry_name.map((c) => (
                                                    <option key={c.cntry_id} value={c.cntry_id}>
                                                        {c.cntry_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* State */}
                                        <div className="staff-group">
                                            <h6><span style={{ color: "red" }}>*</span>State</h6>
                                            <select
                                                className="form-control select"
                                                value={HospState}
                                                onChange={(e) => onStateChange(e.target.value)}
                                            >
                                                <option value="">Select</option>
                                                {state_name.map((s) => (
                                                    <option key={s.state_id} value={s.state_id}>
                                                        {s.state_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* District */}
                                        <div className="staff-group">
                                            <h6><span style={{ color: "red" }}>*</span>District</h6>
                                            <select
                                                className="form-control select"
                                                value={HospDistrict}
                                                onChange={(e) => setHospDistrict(e.target.value)}
                                            >
                                                <option value="">Select</option>
                                                {district_name.map((d) => (
                                                    <option key={d.district_id} value={d.district_id}>
                                                        {d.district_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Added: Served By (Staff) field */}
                                        <div className="staff-group">
                                            <h6>Served By (Staff)</h6>
                                            <select
                                                className="form-control select"
                                                name="hosp_servedby"
                                                value={HospServedBy}
                                                onChange={(e) => setHospServedBy(e.target.value)}
                                            >
                                                <option value="">Select Staff</option>
                                                {staffList.map((staff) => (
                                                    <option key={staff.staff_id} value={staff.staff_id}>
                                                        {staff.staff_name} - {staff.staff_code}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div className="staff-column">
                            <div className="staff-card">
                                <div className="staff-card-body">

                                    <div className="staff-fields">

                                        <div className="staff-group">
                                            <label>Address <span className="staff-required">*</span></label>
                                            <textarea
                                                rows="3"
                                                value={HospAddress}
                                                onChange={(e) => setHospAddress(e.target.value)}
                                                required
                                            ></textarea>
                                        </div>

                                        <div className="staff-group">
                                            <label>Pin Code <span className="staff-required">*</span></label>
                                            <input
                                                type="text"
                                                value={HospPin}
                                                onChange={(e) => setHospPin(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                value={HospEmail}
                                                onChange={(e) => setHospEmail(e.target.value)}
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Website</label>
                                            <input
                                                type="url"
                                                value={HospWebsite}
                                                onChange={(e) => setHospWebsite(e.target.value)}
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Coordinates</label>
                                            <input
                                                type="text"
                                                value={HospCoord}
                                                placeholder="Lat, Long"
                                                onChange={(e) => setHospCoord(e.target.value)}
                                            />
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="staff-btn-container">
                        <button type="submit" className="staff-btn">Update</button>
                    </div>
                </form>
            </div>
        </div>
    )

}
export default EditHospitals;